<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import PreviewAddress from '@/components/preview-address';
import JobStatus from '@/components/job-status';
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  name: "JobList",
  page: {
    title: "Manajemen Job",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, DatePicker, PreviewAddress, JobStatus },
  data() {
    return {
      title: "Manajemen Job",
      items: [
        {
          text: "Manajemen Job",
        },
      ],
      tabIndex: 0,
      tabStatus: null,
      filter: {
        startDate: null,
        endDate: null,
        status: null,
        search: null
      },
      submitType: "",
      statusList: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      jobList: [],
      counter: {
        menunggu_penawaran: 0,
        proses_negosiasi: 0,
        menunggu_pembayaran: 0,
        menunggu_assign_driver: 0,
        menunggu_dokumen: 0,
        menunggu_pickup: 0,
        proses_pickup: 0,
        proses_pengiriman: 0,
        unloading: 0,
        payment: 0,
        selesai: 0,
        batal: 0,
      }
    };
  },
  watch: {
    currentPage() {
      this.getData()
    },
    tabIndex() {
      this.filter.search = null
      if (this.tabStatus === null) {
        if (this.currentPage === 1) {
          this.getData()
        } else {
          this.currentPage = 1
        }
      } else {
        this.tabStatus = null
      }
    },
    tabStatus() {
      if (this.currentPage === 1) {
        this.getData()
      } else {
        this.currentPage = 1
      }
    }
  },
  computed: {
    totalMenungguPenawaran() {
      return this.counter.menunggu_penawaran + this.counter.proses_negosiasi + this.counter.menunggu_pembayaran
    },
    totalOnGoing() {
      return this.counter.menunggu_assign_driver + this.counter.menunggu_dokumen + this.counter.menunggu_pickup
        + this.counter.proses_pickup + this.counter.proses_pengiriman + this.counter.unloading + this.counter.payment
    }
  },
  created() {
    if (this.$route.query.tab !== undefined) {
      this.tabIndex = Number(this.$route.query.tab)
    }
    this.getData()
    this.getCounter()
  },
  methods: {
    getData() {
      let statusParam = null
      let statusPublish = 'published'
      if (this.tabStatus === null) {
        switch (this.tabIndex) {
          case 0:
            statusParam = 'all_penawaran'
            break
          case 1:
            statusParam = 'all_ongoing'
            break
          case 2:
            statusParam = 11
            break
          default:
            statusParam = 12
            break
        }
      } else {
        statusParam = this.tabStatus
      }

      if (this.tabIndex == 4) {
        statusPublish = 'draft'
        statusParam = null
      }

      this.$axios.get('v1/logistic_company/job', {
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          orderby: 'updated_at',
          sort: 'desc',
          logistic_company_id: this.$store.getters.logistic_company.id,
          start_date: this.formatDateForParam(this.filter.startDate),
          end_date: this.formatDateForParam(this.filter.endDate),
          status: statusParam,
          status_publish: statusPublish,
          key: this.filter.search
        }
      }).then((response) => {
          this.jobList = response.data.data.rows
          this.totalRows = response.data.data.total_data
        })
    },
    checkVariant(value) {
      return this.tabStatus === value ? 'danger' : 'outline-danger'
    },
    showPopUpFilter() {
      if (this.tabIndex === 0) {
        this.statusList = [
          { value: null, text: 'Semua Status' },
          { value: 1, text: 'Menunggu Penawaran' },
          { value: 2, text: 'Proses Negosiasi' },
          { value: 3, text: 'Menunggu Pembayaran' },
        ]
      } else if (this.tabIndex === 1) {
        this.statusList = [
          { value: null, text: 'Semua Status' },
          { value: 4, text: 'Menunggu Assign Driver' },
          { value: 5, text: 'Menunggu Dokumen' },
          { value: 6, text: 'Menunggu Pick Up' },
          { value: 7, text: 'Proses Pick Up' },
          { value: 8, text: 'Proses Pengiriman' },
          { value: 9, text: 'Unloading - Upload Dokumen' },
          { value: 10, text: 'Payment - Menunggu Verifikasi Dokumen' },
        ]
      } else {
        this.statusList = []
        this.filter.status = null
      }
      this.$refs.modalFilter.show();
    },
    submitAdvanceFilter(type) {
      this.submitType = type
      if (this.filter.status) {
        this.tabStatus = this.filter.status
      }
      this.$refs.submit.click()
    },
    advancedFilter() {
      if (this.submitType == 'search') {
        // apply filter
        if (this.currentPage === 1) {
          this.getData()
        } else {
          this.currentPage = 1
        }
        this.$refs.modalFilter.hide();
      } else if (this.submitType == 'reset') {
        // reset filter
        if (this.filter.status) {
          this.tabStatus = null
        }
        this.filter = {
          startDate: null,
          endDate: null,
          status: null
        },
        this.$v.$reset();
        if (this.currentPage === 1) {
          this.getData()
        } else {
          this.currentPage = 1
        }
        this.$refs.modalFilter.hide();
      } else {
        // download excel
        let statusParam = null
        let statusPublish = 'published'
        if (this.tabStatus === null) {
          switch (this.tabIndex) {
            case 0:
              statusParam = 'all_penawaran'
              break
            case 1:
              statusParam = 'all_ongoing'
              break
            case 2:
              statusParam = 11
              break
            default:
              statusParam = 12
              break
          }
        } else {
          statusParam = this.tabStatus
        }

        if (this.tabIndex == 4) {
          statusPublish = 'draft'
          statusParam = null
        }

        this.$axios.get('v1/logistic_company/job/export', {
          params: {
            orderby: 'updated_at',
            sort: 'desc',
            logistic_company_id: this.$store.getters.logistic_company.id,
            start_date: this.formatDateForParam(this.filter.startDate),
            end_date: this.formatDateForParam(this.filter.endDate),
            status: statusParam,
            status_publish: statusPublish
          },
          responseType: 'blob'
        }).then((response) => {
          // create file link in browser's memory
          const href = URL.createObjectURL(response.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', 'jobs.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        })
      }
    },
    minDate(date) {
      if (this.filter.startDate === null) {
        return date < new Date(new Date());
      } else {
        return date < moment(this.filter.startDate).toDate()
      }
    },
    goToDetail(job) {
      if (job.status_publish == 'draft') {
        this.$router.push(`/job/${job.id}/edit`)
      } else {
        this.$router.push(`/job/${job.id}`)
      }
    },
    getCounter() {
      this.$axios.get('/v1/logistic_company/job/counter')
        .then(result => {
          result.data.data.forEach(data => {
            switch (data.status) {
              case 1:
                this.counter.menunggu_penawaran = data.total
                break;
              case 2:
                this.counter.proses_negosiasi = data.total
                break;
              case 3:
                this.counter.menunggu_pembayaran = data.total
                break;
              case 4:
                this.counter.menunggu_assign_driver = data.total
                break;
              case 5:
                this.counter.menunggu_dokumen = data.total
                break;
              case 6:
                this.counter.menunggu_pickup = data.total
                break;
              case 7:
                this.counter.proses_pickup = data.total
                break;
              case 8:
                this.counter.proses_pengiriman = data.total
                break;
              case 9:
                this.counter.unloading = data.total
                break;
              case 10:
                this.counter.payment = data.total
                break;
              case 11:
                this.counter.selesai = data.total
                break;
              case 12:
                this.counter.batal = data.total
                break;
            }
          })
        })
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex" justified align="left" nav-class="nav-tabs-custom">
          <b-tab>
            <template v-slot:title>
              <span v-if="totalMenungguPenawaran" class="badge-notif mr-2" data-badge>
                Menunggu Penawaran &nbsp;
              </span>
              <span v-else> Menunggu Penawaran</span>
            </template>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span v-if="totalOnGoing" class="badge-notif mr-2" data-badge>
                On Going &nbsp;
              </span>
              <span v-else> On Going</span>
            </template>
          </b-tab>
          <b-tab title="Selesai"></b-tab>
          <b-tab title="Batal"></b-tab>
          <b-tab title="Draft"></b-tab>
        </b-tabs>
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-10 col-md-10">
                <div id="tickets-table_length" class="dataTables_length">
                  <div class="d-flex justify-content-left" v-if="tabIndex == 0">
                    <b-button type="button" variant="danger" class="w-100 rounded m-1" :class="[ this.tabStatus == null ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = null">Semua</b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 1 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 1">
                      Menunggu penawaran
                      <span v-if="counter.menunggu_penawaran" class="badge badge-pill" :class="tabStatus == 1 ? 'badge-light' : 'badge-danger'">
                        {{ counter.menunggu_penawaran }}
                      </span>
                    </b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 2 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 2">
                      Proses Negosiasi
                      <span v-if="counter.proses_negosiasi" class="badge badge-pill" :class="tabStatus == 2 ? 'badge-light' : 'badge-danger'">
                        {{ counter.proses_negosiasi }}
                      </span>
                    </b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 3 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 3">
                      Menunggu Pembayaran
                      <span v-if="counter.menunggu_pembayaran" class="badge badge-pill" :class="tabStatus == 3 ? 'badge-light' : 'badge-danger'">
                        {{ counter.menunggu_pembayaran }}
                      </span>
                    </b-button>
                    <b-button variant="danger" type="button" class="ml-2 w-100 m-1" @click="showPopUpFilter">Pencarian</b-button>
                  </div>
                  <div class="d-flex justify-content-left" v-if="tabIndex == 1">
                    <b-button type="button" variant="danger" class="w-100 rounded m-1" :class="[ this.tabStatus == null ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = null">Semua</b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 4 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 4">
                      <span>Menunggu Assign Driver &nbsp;</span>
                      <span v-if="counter.menunggu_assign_driver" class="badge badge-pill" :class="tabStatus == 4 ? 'badge-light' : 'badge-danger'">
                        {{ counter.menunggu_assign_driver }}
                      </span>
                    </b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 5 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 5">
                      <span>Menunggu Dokumen &nbsp;</span>
                      <span v-if="counter.menunggu_dokumen" class="badge badge-pill" :class="tabStatus == 5 ? 'badge-light' : 'badge-danger'">
                        {{ counter.menunggu_dokumen }}
                      </span>
                    </b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 6 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 6">
                     <span> Menunggu Pick Up &nbsp;</span>
                      <span v-if="counter.menunggu_pickup" class="badge badge-pill" :class="tabStatus == 6 ? 'badge-light' : 'badge-danger'">
                        {{ counter.menunggu_pickup }}
                      </span>
                    </b-button>
                  </div>
                  <div class="d-flex justify-content-left mt-1" v-if="tabIndex == 1">
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 7 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 7">
                      <span>Proses Pick Up &nbsp;</span>
                      <span v-if="counter.proses_pickup" class="badge badge-pill" :class="tabStatus == 7 ? 'badge-light' : 'badge-danger'">
                        {{ counter.proses_pickup }}
                      </span>
                    </b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 8 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 8">
                      <span>Proses Pengiriman &nbsp;</span>
                      <span v-if="counter.proses_pengiriman" class="badge badge-pill" :class="tabStatus == 8 ? 'badge-light' : 'badge-danger'">
                        {{ counter.proses_pengiriman }}
                      </span>
                    </b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 9 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 9">
                      <span>Unloading - Upload Dokumen &nbsp;</span>
                      <span v-if="counter.unloading" class="badge badge-pill" :class="tabStatus == 9 ? 'badge-light' : 'badge-danger'">
                        {{ counter.unloading }}
                      </span>
                    </b-button>
                    <b-button type="button" variant="danger" class="w-100 rounded m-1 no-wr" :class="[ this.tabStatus == 10 ? 'job-tab-active' : 'job-tab' ]" @click="tabStatus = 10">
                      <span>Payment - Menunggu Verifikasi Dokumen &nbsp;</span>
                      <span v-if="counter.payment" class="badge badge-pill" :class="tabStatus == 10 ? 'badge-light' : 'badge-danger'">
                        {{ counter.payment }}
                      </span>
                    </b-button>
                  </div>
                  <div class="d-flex justify-content-left" v-if="tabIndex >= 2">
                    <b-button variant="danger" type="button" class="w-20" @click="showPopUpFilter">Pencarian</b-button>
                  </div>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-2 col-md-2">
                <b-button v-if="tabIndex == 1" variant="danger" type="button" class="mb-1 ml-2 w-100" @click="showPopUpFilter">Pencarian</b-button>
                <b-button to="/job/create" :disabled="$store.state.userdata.logistic_company.document_status !== 'disetujui' || $store.state.userdata.logistic_company.account_status !== 'aktif'" variant="danger" type="button" class="ml-2 w-100">Buat Job</b-button>
              </div>
              <!-- End search -->
            </div>
            <div class="list-job mx-2">
              <b-card
                v-for="(job, index) in jobList"
                :key="index"
                class="border border-4 border-light mb-2 cursor-pointer"
                @click="goToDetail(job)"
              >
                <template v-slot:header>
                  <div  class="d-flex justify-content-between align-items-center">
                    <div class="col-lg-6">
                      <p class="mb-0">
                        <span class="font-weight-bolder">
                          {{ job.code }}
                        </span>
                        -
                        <span class="font-weight-bolder">
                          {{ job.published_at | date_only }}
                        </span>
                      </p>
                    </div>
                    <div class="col-lg-6 text-right">
                      <JobStatus v-if="job.status_publish == 'published'" :status="job.status" />
                    </div>
                  </div>
                </template>
                <b-card-body>
                  <div class="row d-flex justify-content-between align-items-center">
                    <div class="col-lg-6">
                      <p class="font-weight-light m-0">
                        <PreviewAddress
                          :type="'pickup'"
                          :list-address="job.addresses"
                        />
                      </p>
                    </div>
                    <div class="col-lg-6">
                      <p class="font-weight-light m-0">
                        <PreviewAddress
                          :type="'dropoff'"
                          :list-address="job.addresses"
                        />
                      </p>
                    </div>
                  </div>
                  <hr class="m-2" />
                  <div class="justify-content-between d-flex align-items-center">
                    <p class="float-left font-weight-bolder mb-0">
                      {{ job.pic_name }} - {{ job.pic_phone }}
                    </p>
                    <p v-if="job.offer_price && job.status >= 3" class="float-right font-weight-bolder mb-0">
                      {{ job.offer_price | convertToRupiah }}
                    </p>
                  </div>
                </b-card-body>
              </b-card>
              <div class="row border-radius py-3 my-3 cursor-pointer job" v-if="jobList.length === 0">
                <div class="col-sm-12 text-center font-size-24">
                  Data tidak ditemukan
                </div>
              </div>
            </div>
            <div class="row" v-if="jobList.length > 0">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal filter -->
    <b-modal title="Pencarian" id="modal-filter" ref="modalFilter" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-form @submit.prevent="advancedFilter">
        <button ref="submit" type="submit" style="display:none;">Submit</button>
        <div class="form-group row mb-0">
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Tanggal Awal</label>
              <date-picker
                v-model="filter.startDate"
                :first-day-of-week="1"
                format="DD/MM/YYYY"
                lang="en"
              ></date-picker>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Tanggal Akhir</label>
              <date-picker
                v-model="filter.endDate"
                :first-day-of-week="1"
                :disabled-date="minDate"
                format="DD/MM/YYYY"
                lang="en"
              ></date-picker>
            </div>
          </div>
        </div>
        <b-form-group id="status-group" label="Status" label-for="status" v-if="tabIndex < 2" class="mb-0">
          <b-form-select class="form-control" v-model="filter.status" :options="statusList"></b-form-select>
        </b-form-group>
        <b-form-group id="cari-group" label="Nomor Job" label-for="cari" class="mb-0 mt-3">
          <b-form-input id="search" name="search" v-model="filter.search" type="text"></b-form-input>
        </b-form-group>
        <div class="mt-3">
          <b-button type="button" @click="submitAdvanceFilter('search')" variant="success">Cari</b-button>
          <b-button type="button" @click="submitAdvanceFilter('download')" variant="danger" class="ml-2">Download Excel</b-button>
          <b-button type="button" @click="submitAdvanceFilter('reset')" variant="warning" class="ml-2">Reset Pencarian</b-button>
        </div>
      </b-form>
    </b-modal>
    <!-- /.modal -->
  </Layout>
</template>


<style scoped>
.nav-tabs-custom {
  border-bottom: 2px solid #dee2e6
}
.nav-tabs-custom .nav-item .nav-link.active {
  color:#f01b3c !important
}
.icon-panah {
  position: absolute;
  top: 35%;
  left: 0%;
}

.card-body {
  padding: 5px 15px !important;
}

.border-light {
  border-color: #e9ecef!important;
}
.content-slider {
  position: relative;
}
.nav-kiri {
  cursor: pointer;
  position: absolute;
  top: 45%;
  left: 5%;
}
.nav-kanan {
  cursor: pointer;
  position: absolute;
  top: 45%;
  right: 5%;
}

.total-job {
  position: absolute;
  top: 25%;
  right: 50%;
}

.job:hover {
  background-color: aliceblue;
  color: #f80606;
  font-weight: bold;
}

.no-wr {
  white-space: nowrap;
}

.badge-notif {
  position: relative;
}

.badge-notif[data-badge]:after {
  content: attr(data-badge);
  position: absolute;
  top: 0px;
  right: -18px;
  font-size: 0.51em;
  background: #e53935;
  color: white;
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 18px;
  border-radius: 50%;
}
</style>